<template>
  <section class="batch-modify">
    <header class="batch-head">
      <div class="crumb">
        <button
          class="plain"
          :disabled="Boolean(pendingCreate) || confirming"
          @click="$emit('back')"
        >
          ‹ 返回</button
        ><span>商品工作台　›　批量修改　›　<strong>SKU编码</strong></span>
      </div>
      <h1>批量修改SKU编码</h1>
      <nav>
        <button
          v-for="tab in tabs"
          :key="tab.value"
          :class="{ active: mode === tab.value }"
          :disabled="confirming || Boolean(pendingCreate)"
          @click="switchMode(tab.value)"
        >
          {{ tab.label }}
        </button>
      </nav>
    </header>
    <main :inert="Boolean(pendingCreate)">
      <section class="panel">
        <div v-if="mode === 'products'" class="picked">
          <button @click="openSelector">选择商品</button
          ><span
            >已选择 <b>{{ selected.length }}</b> 个商品</span
          >
        </div>
        <div v-if="mode === 'product_ids'" class="ids">
          <label>抖店商品 ID</label
          ><el-input
            v-model="idsText"
            type="textarea"
            :rows="3"
            placeholder="多个 ID 用逗号、空格或换行分隔"
          />
        </div>
        <div v-if="mode === 'range'" class="filters">
          <label v-for="field in shownFields" :key="field.key" class="field"
            ><span
              >{{ field.label
              }}<small v-if="field.runtime">（需核验数据）</small></span
            >
            <doudian-category-cascader
              v-if="field.key === 'category_id'"
              v-model="filters.category_id"
              :categories="categories"
            />
            <el-date-picker
              v-else-if="field.date"
              v-model="filters[field.key]"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            />
            <div v-else-if="field.matchKey" class="combined-control">
              <el-select v-model="filters[field.matchKey]"
                ><el-option
                  v-for="o in field.matchOptions"
                  :key="o.value"
                  :value="o.value"
                  :label="o.label"
              /></el-select>
              <div v-if="field.range" class="range">
                <input
                  v-model="filters[field.key + '_min']"
                  placeholder="最小值"
                /><span>~</span
                ><input
                  v-model="filters[field.key + '_max']"
                  placeholder="最大值"
                />
              </div>
              <input
                v-else
                v-model="filters[field.key]"
                :placeholder="field.placeholder || '请输入' + field.label"
              />
            </div>
            <div v-else-if="field.range" class="range">
              <input
                v-model="filters[field.key + '_min']"
                placeholder="最小值"
              /><span>~</span
              ><input
                v-model="filters[field.key + '_max']"
                placeholder="最大值"
              />
            </div>
            <el-select
              v-else-if="field.options"
              v-model="filters[field.key]"
              clearable
              ><el-option
                v-for="o in field.options"
                :key="String(o.value)"
                :value="o.value"
                :label="o.label"
            /></el-select>
            <input
              v-else
              v-model="filters[field.key]"
              :placeholder="field.placeholder || '请输入条件'"
            />
          </label>
        </div>
        <footer v-if="mode !== 'products'" class="filter-actions">
          <doudian-batch-shop-scope
            v-model="shops"
            :shops="shopOptions"
            :disabled="confirming"
          />
          <div class="filter-buttons">
            <button
              :disabled="loading || confirming || Boolean(pendingCreate)"
              @click="loadPreview(1)"
            >
              查询</button
            ><button class="plain" @click="resetFilters">重置</button>
          </div>
        </footer>
        <p v-if="mode === 'range'" class="hint">
          预览只读本地；本地未命中跳过，符合或缺数据的候选在执行时读取抖店详情复核。
        </p>
      </section>
      <doudian-batch-common-options
        v-model="commonOptions"
        :disabled="loading || confirming"
      />
      <section class="panel methods code-scope-panel">
        <h3><i></i>修改范围</h3>
        <div class="code-scope-body">
          <div class="code-scope-row">
            <span class="code-scope-label">SKU范围：</span>
            <el-radio-group v-model="skuScope">
              <el-radio label="all">针对全部SKU</el-radio>
              <el-radio label="empty_code">针对SKU编码为空的SKU</el-radio>
            </el-radio-group>
          </div>
          <div class="spec-name-scope code-scope-row">
            <span class="code-scope-label">规格名称筛选：</span>
            <el-radio-group v-model="specEnabled">
              <el-radio :label="false">针对所有的SKU规格名称</el-radio>
              <el-radio :label="true">针对符合条件的SKU规格名称</el-radio>
            </el-radio-group>
            <el-select v-model="specMode" :disabled="!specEnabled"
              ><el-option label="包含任一关键词" value="contains" /><el-option
                label="不包含所有关键词"
                value="not_contains" /><el-option
                label="精确匹配"
                value="exact" /></el-select
            ><el-input
              v-model="keywordsText"
              :disabled="!specEnabled"
              placeholder="多个关键词用逗号隔开，最多100个"
            />
          </div>
        </div>
      </section>
      <section class="panel methods code-methods">
        <h3><i></i>修改内容</h3>
        <p class="hint code-capability-hint">
          缺少来源字段时显示待核验；编码最多128字符，重复或未核验清空会阻止该商品修改。<span
            v-if="capabilityError"
            class="warning"
            >{{ capabilityError }}</span
          >
        </p>
        <div
          v-for="(method, index) in methods"
          :key="method.value"
          class="code-method-row"
        >
          <el-radio v-model="codeMethod" :label="method.value"
            >方式{{ index + 1 }}：{{ method.label }}</el-radio
          >
          <sku-code-rule-fields
            v-if="method.value !== 'multi'"
            v-model="forms[method.value]"
            :method="method.value"
            :variables="variables"
            :chinese-modes="chineseModes"
          />
          <div v-else class="code-multi-options">
            <div
              v-for="option in multiOptions"
              :key="option.value"
              class="code-multi-option"
              :class="{ 'is-disabled': !multiEnabled[option.value] }"
            >
              <el-checkbox v-model="multiEnabled[option.value]">
                {{ option.label }}
              </el-checkbox>
              <sku-code-rule-fields
                v-model="multiForms[option.value]"
                :method="option.value"
                :variables="variables"
                :chinese-modes="chineseModes"
                :disabled="!multiEnabled[option.value]"
              />
            </div>
            <p class="hint">勾选的规则按上方显示顺序依次处理同一SKU编码。</p>
          </div>
        </div>
      </section>
      <section v-if="preview" class="panel preview">
        <header class="preview-summary">
          <span
            >候选商品 <b>{{ preview.total }}</b> 个；本页预计命中
            {{ (preview.page_match_counts || {}).matched || 0 }}、预计跳过
            {{ (preview.page_match_counts || {}).unmatched || 0 }}、待核验
            {{ (preview.page_match_counts || {}).unknown || 0 }}</span
          ><button class="plain" @click="closePreview">收起预览</button>
        </header>
        <div class="preview-details">
          <span>预览只读取本地快照，真实命中以执行时的抖店详情复核为准。</span
          ><span v-if="!previewCurrent" class="warning"
            >条件已变化，请重新预览。</span
          >
        </div>
        <div class="table-wrap">
          <table class="price-preview-table">
            <thead>
              <tr>
                <th>商品信息</th>
                <th>SKU信息</th>
                <th>状态</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in preview.list || []" :key="item.id">
                <td>
                  <div class="preview-product">
                    <el-image
                      class="preview-product-image"
                      :src="item.main_image"
                      fit="cover"
                      ><span slot="error">暂无图片</span></el-image
                    >
                    <div>
                      <small>{{ item.shop_name }}</small>
                      <p>{{ item.product_title }}</p>
                      <small>商品 ID：{{ item.platform_product_id }}</small>
                    </div>
                  </div>
                </td>
                <td>
                  <details
                    class="price-sku-list"
                    :open="expandedSkuId === String(item.id)"
                  >
                    <summary @click.prevent="previewSkus(item)">
                      {{
                        skuLoading && expandedSkuId === String(item.id)
                          ? '加载中'
                          : 'SKU明细'
                      }}
                    </summary>
                    <div class="sku-detail-content">
                      <p v-if="skuLoading">SKU 明细加载中…</p>
                      <p v-else-if="skuError" class="sku-error">
                        {{ skuError }}
                      </p>
                      <p
                        v-else-if="
                          !skuPreviewCache[String(item.id)] ||
                          !skuPreviewCache[String(item.id)].length
                        "
                      >
                        暂无 SKU 明细
                      </p>
                      <table v-else class="sku-table">
                        <thead>
                          <tr>
                            <th>规格</th>
                            <th>原编码</th>
                            <th>新编码</th>
                            <th>状态</th>
                            <th>说明</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="sku in skuPreviewCache[String(item.id)]"
                            :key="String(sku.sku_id)"
                            :class="`sku-${sku.match_result || 'unknown'}`"
                          >
                            <td>{{ sku.sku_spec_text || '规格待核验' }}</td>
                            <td>
                              {{
                                sku.value_ready
                                  ? sku.old_code === ''
                                    ? '（空）'
                                    : sku.old_code
                                  : '待核验'
                              }}
                            </td>
                            <td>
                              {{
                                sku.new_value_ready
                                  ? (sku.new_code === ''
                                      ? '（空）'
                                      : sku.new_code) +
                                    (sku.is_random_example
                                      ? '（随机示例）'
                                      : '')
                                  : '待核验'
                              }}
                            </td>
                            <td>
                              {{
                                sku.match_result === 'matched' &&
                                sku.reason &&
                                sku.new_value_ready
                                  ? '无法修改'
                                  : matchLabel(sku.match_result)
                              }}
                            </td>
                            <td>
                              {{ sku.reason ? reasonLabel(sku.reason) : '—' }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <el-pagination
                        v-if="skuPages[String(item.id)]"
                        small
                        layout="prev, pager, next"
                        :page-size="100"
                        :current-page="skuPages[String(item.id)].page"
                        :total="skuPages[String(item.id)].total"
                        @current-change="loadSkuPage(item, $event)"
                      />
                    </div>
                  </details>
                </td>
                <td>
                  <span
                    class="match-badge"
                    :class="resultClass(item.preview_result)"
                    >{{ resultLabels[item.preview_result] || '待核验' }}</span
                  >
                  <p
                    v-if="item.match_reason || item.reason || item.error_msg"
                    class="preview-reason"
                  >
                    {{
                      reasonLabel(
                        item.match_reason || item.reason || item.error_msg
                      )
                    }}
                  </p>
                </td>
                <td>
                  <el-checkbox
                    :value="excluded.includes(Number(item.id))"
                    @change="exclude(item.id, $event)"
                    >排除修改</el-checkbox
                  >
                </td>
              </tr>
              <tr v-if="!preview.list || !preview.list.length">
                <td colspan="4">暂无候选商品</td>
              </tr>
            </tbody>
          </table>
        </div>
        <footer class="preview-pagination">
          <el-pagination
            small
            layout="prev, pager, next"
            :current-page="preview.page"
            :page-size="preview.limit"
            :total="preview.total"
            @current-change="loadPreview"
          />
        </footer>
      </section>
    </main>
    <p v-if="pendingCreate" class="warning">
      创建结果尚未确认，表单已锁定。请点击“确认创建结果”，按原请求查回批次，勿重复创建。
    </p>
    <footer class="actions">
      <button
        class="preview-button"
        :disabled="loading || confirming || Boolean(pendingCreate)"
        @click="loadPreview(1)"
      >
        {{ loading ? '加载中…' : '编码修改预览' }}</button
      ><button
        class="start"
        :disabled="
          loading ||
          confirming ||
          (!pendingCreate && (!previewCurrent || !preview.total))
        "
        @click="createBatch"
      >
        {{
          confirming
            ? '处理中…'
            : pendingCreate
            ? '确认创建结果'
            : '开始批量修改'
        }}</button
      ><label
        ><input
          v-model="scheduled"
          type="checkbox"
          :disabled="confirming"
          @change="toggleSchedule"
        />定时执行</label
      ><button
        v-if="scheduled"
        class="time"
        :disabled="confirming"
        @click="scheduleVisible = true"
      >
        {{ scheduledAt || '选择时间' }}
      </button>
    </footer>
    <div v-if="scheduleVisible" class="schedule-mask">
      <section class="schedule-modal">
        <header>
          <strong>定时执行</strong
          ><button @click="scheduleVisible = false">×</button>
        </header>
        <main>
          <el-date-picker
            v-model="scheduleDraft"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            placeholder="选择北京时间"
          />
        </main>
        <footer>
          <button class="plain" @click="scheduleVisible = false">取消</button
          ><button @click="confirmSchedule">确定</button>
        </footer>
      </section>
    </div>
    <product-selector-dialog
      @page-size-change="changeSelectorPageSize"
      :visible="selectorVisible"
      :active-tab="selectorTab"
      :products="selectorProducts"
      :selected-ids="draftSelected.map(productId)"
      :loading="selectorLoading"
      :page="selectorPage"
      :page-size="selectorPageSize"
      :page-sizes="[20, 50, 100, 500, 1000]"
      :total="selectorTab === 'selected' ? draftSelected.length : selectorTotal"
      :total-pages="selectorPages"
      :jump-page="selectorJump"
      :page-fully-selected="
        selectorRows.length > 0 && selectorRows.every(isSelected)
      "
      :product-id="productId"
      :product-key="productId"
      :product-title="productTitle"
      :product-image="productImage"
      :product-price="productPrice"
      @tab-change="changeSelectorTab"
      @close="selectorVisible = false"
      @toggle-product="toggleProduct"
      @toggle-page="togglePage"
      @page-change="changeSelectorPage"
      @jump-input="selectorJump = $event"
      @jump="changeSelectorPage(Number(selectorJump))"
      @confirm="confirmSelected"
      ><template #filters
        ><doudian-product-selector-filters
          :value="selectorFilters"
          :shop-id="selectorShopId"
          :shops="shopOptions"
          :categories="categories"
          @shop-change="changeSelectorShop"
          @query="loadSelector(1)" /></template
    ></product-selector-dialog>
  </section>
</template>

<script>
import SkuCodeRuleFields, {
  newCodeOptions,
  CODE_METHODS,
} from './SkuCodeRuleFields.vue'
import DoudianBatchShopScope from '@/components/DoudianBatchShopScope'
import {
  previewDoudianSkuCodeBatch,
  previewDoudianSkuCodeSkus,
  createDoudianSkuCodeBatch,
  getDoudianSkuCodeCapabilities,
  getDoudianCategories,
  getAuthSuccessShopList,
  getProductSelectorProducts,
} from '@/api/main/doudianBatchEdit'
import DoudianCategoryCascader from '@/components/DoudianCategoryCascader'
import ProductSelectorDialog from '@/components/ProductSelectorDialog/ProductSelectorDialog'
import DoudianProductSelectorFilters from './DoudianProductSelectorFilters.vue'
import DoudianBatchCommonOptions from '@/components/DoudianBatchCommonOptions'
import {
  fields,
  pairedFields,
  defaults,
  buildBatchProductFilter,
} from './batchModifyFilters'

export default {
  name: 'BatchModifySkuCode',
  components: {
    SkuCodeRuleFields,
    DoudianBatchShopScope,
    DoudianCategoryCascader,
    ProductSelectorDialog,
    DoudianProductSelectorFilters,
    DoudianBatchCommonOptions,
  },
  data: () => ({
    tabs: [
      { value: 'range', label: '按范围修改' },
      { value: 'products', label: '按商品修改' },
      { value: 'product_ids', label: '按商品 ID 修改' },
    ],
    mode: 'range',
    fields,
    filters: defaults(),
    shops: [],
    shopOptions: [],
    categories: [],
    selected: [],
    excluded: [],
    idsText: '',
    skuScope: 'all',
    specEnabled: false,
    specMode: 'contains',
    keywordsText: '',
    methods: CODE_METHODS,
    codeMethod: 'template',
    multiOptions: [
      { value: 'delete_keywords', label: '删除关键词' },
      { value: 'replace_exact', label: 'SKU关键词精准替换' },
      { value: 'spec_exact', label: 'SKU规格名称精准替换' },
      { value: 'affix', label: '添加前后缀' },
    ],
    forms: Object.fromEntries(
      CODE_METHODS.slice(0, 9).map((m) => [m.value, newCodeOptions(m.value)])
    ),
    multiEnabled: {
      delete_keywords: false,
      replace_exact: false,
      spec_exact: false,
      affix: false,
    },
    multiForms: {
      delete_keywords: newCodeOptions('delete_keywords'),
      replace_exact: newCodeOptions('replace_exact'),
      spec_exact: newCodeOptions('spec_exact'),
      affix: newCodeOptions('affix'),
    },
    variables: [],
    chineseModes: ['none', 'remove'],
    capabilityError: '',
    pendingCreate: null,
    skuPages: {},
    commonOptions: { auto_generate_size_chart: false, shelf_action: 0 },
    scheduled: false,
    scheduledAt: '',
    scheduleDraft: '',
    scheduleVisible: false,
    preview: null,
    signature: '',
    loading: false,
    confirming: false,
    previewRequest: 0,
    skuPreviewRequest: 0,
    expandedSkuId: null,
    skuPreviewCache: {},
    skuLoading: false,
    skuError: '',
    requestId: '',
    selectorVisible: false,
    selectorTab: 'all',
    selectorLoading: false,
    selectorRows: [],
    selectorPageSize: 20,
    selectorPage: 1,
    selectorTotal: 0,
    selectorJump: 1,
    selectorShopId: '',
    selectorFilters: {
      category_id: { level1: [], level2: [], level3: [] },
      platform_product_id: '',
      product_title: '',
      created_at: [],
      tab_status: '',
    },
    draftSelected: [],
    selectorRequest: 0,
    resultLabels: {
      ready: '预计命中',
      skipped: '预计跳过',
      unknown: '待核验',
      failed: '预计失败',
    },
  }),
  computed: {
    shownFields() {
      return this.fields
        .filter((f) => !Object.values(pairedFields).includes(f.key))
        .map((f) =>
          pairedFields[f.key]
            ? {
                ...f,
                matchKey: pairedFields[f.key],
                matchOptions: this.fields.find(
                  (x) => x.key === pairedFields[f.key]
                ).options,
              }
            : f
        )
    },
    selectorPages() {
      return Math.max(
        1,
        Math.ceil(
          (this.selectorTab === 'selected'
            ? this.draftSelected.length
            : this.selectorTotal) / this.selectorPageSize
        )
      )
    },
    selectorProducts() {
      return this.selectorTab === 'selected'
        ? this.draftSelected.slice(
            (this.selectorPage - 1) * this.selectorPageSize,
            this.selectorPage * this.selectorPageSize
          )
        : this.selectorRows
    },
    previewCurrent() {
      return Boolean(
        this.preview && this.signature === JSON.stringify(this.payload(false))
      )
    },
    keywords() {
      return [
        ...new Set(
          this.keywordsText
            .split(/[,，\r\n]+/)
            .map((v) => v.trim())
            .filter(Boolean)
        ),
      ]
    },
    multiSteps() {
      return this.multiOptions
        .filter((option) => this.multiEnabled[option.value])
        .map((option) => ({
          method: option.value,
          options: JSON.parse(JSON.stringify(this.multiForms[option.value])),
        }))
    },
  },
  watch: {
    shops: {
      deep: true,
      handler() {
        if (this.mode !== 'products') this.selected = []
        this.excluded = []
        this.invalidate()
      },
    },
    mode() {
      this.excluded = []
      this.invalidate()
    },
    filters: {
      deep: true,
      handler() {
        this.invalidate()
      },
    },
    selected: {
      deep: true,
      handler() {
        this.invalidate()
      },
    },
    skuScope() {
      this.invalidate()
    },
    specEnabled() {
      this.invalidate()
    },
    specMode() {
      this.invalidate()
    },
    keywordsText() {
      this.invalidate()
    },
    codeMethod() {
      this.invalidate()
    },
    forms: {
      deep: true,
      handler() {
        this.invalidate()
      },
    },
    multiEnabled: {
      deep: true,
      handler() {
        this.invalidate()
      },
    },
    multiForms: {
      deep: true,
      handler() {
        this.invalidate()
      },
    },
    commonOptions: {
      deep: true,
      handler() {
        this.invalidate()
      },
    },
    scheduledAt() {
      this.invalidate()
    },
    scheduled() {
      this.invalidate()
    },
    idsText() {
      this.invalidate()
    },
  },
  mounted() {
    this.newRequestId()
    this.loadOptions()
    this.loadCapabilities()
  },
  beforeDestroy() {
    this.previewRequest++
    this.skuPreviewRequest++
    this.selectorRequest++
  },
  methods: {
    changeSelectorPageSize(size) {
      this.selectorPageSize = Number(size)
      this.selectorPage = 1
      this.loadSelector(1)
    },
    matchLabel(value) {
      return (
        { matched: '命中', unmatched: '未命中', unknown: '数据不足' }[value] ||
        value
      )
    },
    reasonLabel(value) {
      if (value && value.startsWith('variable_missing:'))
        return '缺少变量来源：' + value.split(':')[1]
      return (
        {
          code_duplicate: '同商品SKU编码重复',
          code_clear_unverified: '当前不支持清空编码',
          code_too_long: '编码超过128字符',
          code_data_unknown: '编码或来源数据不足，执行时核验',
          code_unknown: '原编码缺失',
          sku_type_unknown: 'SKU类型未知或暂不支持',
          no_code_change: '编码无变化',
          sku_identity_unknown: 'SKU标识缺失或重复',
          sku_name_unknown: 'SKU规格名称缺失',
          sku_not_matched: '未命中SKU条件',
          condition_not_matched: '未命中商品条件',
        }[value] ||
        value ||
        '—'
      )
    },
    resultClass(value) {
      return (
        {
          ready: 'match-matched',
          skipped: 'match-unmatched',
          failed: 'match-unmatched',
        }[value] || 'match-unknown'
      )
    },
    newRequestId() {
      this.requestId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        (c) => {
          const r = (Math.random() * 16) | 0
          return (c === 'x' ? r : (r & 3) | 8).toString(16)
        }
      )
    },
    invalidate() {
      this.previewRequest++
      this.skuPreviewRequest++
      this.loading = false
      this.preview = null
      this.signature = ''
      this.expandedSkuId = null
      this.skuPreviewCache = {}
      this.skuLoading = false
      this.skuError = ''
      this.newRequestId()
    },
    closePreview() {
      this.previewRequest++
      this.skuPreviewRequest++
      this.loading = false
      this.preview = null
      this.expandedSkuId = null
      this.skuPreviewCache = {}
      this.skuLoading = false
      this.skuError = ''
    },
    dataOf(r) {
      if (!r || Number(r.code) !== 200) {
        const e = new Error(r?.message || '请求失败')
        e.definite = Boolean(r && r.code != null)
        throw e
      }
      return r.data
    },
    message(e) {
      return e?.response?.data?.message || e?.message || '请求失败'
    },
    async loadOptions() {
      try {
        const data = this.dataOf(await getAuthSuccessShopList())
        this.shopOptions = Array.isArray(data)
          ? data
          : data.list || data.data || []
      } catch (e) {
        this.$message.error(this.message(e))
      }
      try {
        const data = this.dataOf(await getDoudianCategories({ shop_type: 1 }))
        const map = (rows) =>
          rows.map((x) => ({
            ...x,
            category_id: x.id || x.category_id,
            category_name: x.name || x.category_name,
            children: map(x.children || []),
          }))
        this.categories = map(
          Array.isArray(data) ? data : data.list || data.data || []
        )
      } catch (e) {
        this.$message.error(this.message(e))
      }
    },
    payload(includeRequest = true) {
      const productFilter = buildBatchProductFilter(
        this.filters,
        this.shops,
        this.excluded,
        this.mode,
        this.selected.map((x) => String(x.platform_product_id))
      )
      if (this.mode === 'product_ids')
        productFilter.platform_product_id = [
          ...new Set(
            this.idsText
              .split(/[,，\s]+/)
              .map((x) => x.trim())
              .filter(Boolean)
          ),
        ]
      const options =
        this.codeMethod === 'multi'
          ? { steps: this.multiSteps }
          : JSON.parse(JSON.stringify(this.forms[this.codeMethod]))
      const body = {
        selection_mode: this.mode,
        product_filter: productFilter,
        sku_scope: this.skuScope,
        spec_match: this.specEnabled
          ? { enabled: true, mode: this.specMode, keywords: this.keywords }
          : { enabled: false },
        code_rule: { method: this.codeMethod, options },
        common_options: { ...this.commonOptions },
        ...(this.scheduled && this.scheduledAt
          ? { scheduled_at: this.scheduledAt }
          : {}),
      }
      if (includeRequest) body.request_id = this.requestId
      return body
    },
    newCodeOptions,
    async loadCapabilities() {
      try {
        const data = this.dataOf(await getDoudianSkuCodeCapabilities())
        this.variables = data.variables || []
        this.chineseModes = data.chinese_modes || ['none', 'remove']
        this.capabilityError = ''
      } catch (e) {
        this.capabilityError = '变量能力读取失败，请重试进入本页'
        this.$message.error(this.message(e))
      }
    },
    validateCodeRule(method, options) {
      const filled = (value) => typeof value === 'string' && value.trim() !== ''
      if (
        method === 'template' &&
        !options.segments.some(
          (part) => part.kind === 'variable' || filled(part.value)
        )
      )
        throw new Error('请输入自定义编码或选择变量')
      if (
        method === 'affix' &&
        (!options.variable ||
          (!filled(options.prefix) && !filled(options.suffix)))
      )
        throw new Error('请选择变量并输入前缀或后缀')
      if (method === 'delete_keywords' && !options.keywords.some(filled))
        throw new Error('请输入需要删除的关键词')
      if (method === 'set' && !filled(options.value))
        throw new Error('请输入统一修改的编码')
      if (method === 'random' && !options.base_variable)
        throw new Error('请选择随机编码的变量')
      if (
        [
          'replace_contains',
          'replace_exact',
          'spec_contains',
          'spec_exact',
        ].includes(method)
      ) {
        const isSpec = method.startsWith('spec_')
        if (
          !options.rows.length ||
          options.rows.some(
            (row) =>
              !filled(row[isSpec ? 'keyword' : 'find']) ||
              !filled(row[isSpec ? 'value' : 'replacement'])
          )
        )
          throw new Error('请填写每条规则的关键词和替换内容')
      }
    },
    validate() {
      if (this.mode === 'products' && !this.selected.length)
        throw new Error('请选择商品')
      if (
        this.mode === 'product_ids' &&
        !this.payload().product_filter.platform_product_id.length
      )
        throw new Error('请输入抖店商品ID')
      if (
        this.specEnabled &&
        (!this.keywords.length || this.keywords.length > 100)
      )
        throw new Error('规格关键词需为1至100个')
      if (this.codeMethod === 'multi' && !this.multiSteps.length)
        throw new Error('请至少勾选一项多规则修改方式')
      if (this.codeMethod === 'multi')
        this.multiSteps.forEach((step) =>
          this.validateCodeRule(step.method, step.options)
        )
      else this.validateCodeRule(this.codeMethod, this.forms[this.codeMethod])
      if (
        this.scheduled &&
        (!this.scheduledAt ||
          new Date(this.scheduledAt.replace(' ', 'T') + '+08:00') <= new Date())
      )
        throw new Error('请选择未来的执行时间')
    },
    switchMode(mode) {
      if (this.mode !== mode) {
        this.mode = mode
        this.selected = []
        this.idsText = ''
        this.invalidate()
      }
    },
    async loadPreview(page = 1) {
      try {
        this.validate()
      } catch (e) {
        return this.$alert(e.message, '提示', { type: 'warning' }).catch(() => {})
      }
      this.skuPreviewRequest++
      this.expandedSkuId = null
      this.skuPreviewCache = {}
      this.skuLoading = false
      this.skuError = ''
      const req = ++this.previewRequest
      const body = this.payload(false)
      const signature = JSON.stringify(body)
      this.loading = true
      try {
        const data = this.dataOf(
          await previewDoudianSkuCodeBatch({ ...body, page, limit: 20 })
        )
        if (
          req !== this.previewRequest ||
          signature !== JSON.stringify(this.payload(false))
        )
          return
        this.preview = data
        this.signature = signature
      } catch (e) {
        if (req === this.previewRequest) {
          this.invalidate()
          this.$message.error(this.message(e))
        }
      } finally {
        if (req === this.previewRequest) this.loading = false
      }
    },
    async previewSkus(item) {
      const id = String(item.id)
      if (this.expandedSkuId === id) {
        this.expandedSkuId = null
        this.skuPreviewRequest++
        this.skuLoading = false
        return
      }
      this.expandedSkuId = id
      await this.loadSkuPage(item, 1)
    },
    async loadSkuPage(item, page) {
      const id = String(item.id),
        req = ++this.skuPreviewRequest
      const signature = JSON.stringify(this.payload(false))
      this.skuLoading = true
      this.skuError = ''
      try {
        const data = this.dataOf(
          await previewDoudianSkuCodeSkus({
            ...this.payload(false),
            distribute_product_id: Number(item.id),
            page,
            limit: 100,
          })
        )
        if (
          req !== this.skuPreviewRequest ||
          this.expandedSkuId !== id ||
          signature !== JSON.stringify(this.payload(false))
        )
          return
        this.$set(this.skuPreviewCache, id, data.items || [])
        this.$set(this.skuPages, id, { page, total: data.total || 0 })
      } catch (e) {
        if (req === this.skuPreviewRequest) this.skuError = this.message(e)
      } finally {
        if (req === this.skuPreviewRequest) this.skuLoading = false
      }
    },
    async createBatch() {
      if (this.confirming) return
      if (!this.pendingCreate) {
        try {
          this.validate()
          if (!this.previewCurrent) throw new Error('请先预览')
          await this.$confirm(
            `候选${this.preview.total}件，预览为本地估算；随机编码执行时生成。确定开始吗？`,
            '确认修改'
          )
        } catch (e) {
          if (e !== 'cancel' && e !== 'close')
            this.$message.warning(this.message(e))
          return
        }
        if (!this.previewCurrent)
          return this.$message.warning('条件已变化，请重新预览')
        this.pendingCreate = JSON.parse(JSON.stringify(this.payload()))
      }
      this.confirming = true
      try {
        this.dataOf(await createDoudianSkuCodeBatch(this.pendingCreate))
        this.pendingCreate = null
        this.$message.success('任务已创建，请查看批量修改记录')
        this.$emit('created')
      } catch (e) {
        if (e.definite || e?.response?.data?.code) this.pendingCreate = null
        this.$message.error(this.message(e))
      } finally {
        this.confirming = false
      }
    },
    exclude(id, checked) {
      const n = Number(id)
      if (checked && !this.excluded.includes(n)) this.excluded.push(n)
      else this.excluded = this.excluded.filter((x) => x !== n)
      this.invalidate()
    },
    resetFilters() {
      this.filters = defaults()
      this.shops = []
      this.excluded = []
      this.invalidate()
    },
    toggleSchedule() {
      if (!this.scheduled) this.scheduledAt = ''
    },
    confirmSchedule() {
      const ts = new Date(this.scheduleDraft.replace(' ', 'T') + '+08:00')
      if (!this.scheduleDraft || ts <= new Date())
        return this.$message.warning('请选择未来的执行时间')
      this.scheduledAt = this.scheduleDraft + ':00'
      this.scheduleVisible = false
    },
    productId(item) {
      return Number(item.distribute_product_id || item.id)
    },
    productTitle(item) {
      return item.product_title || item.title || ''
    },
    productImage(item) {
      return item.main_image || item.img || ''
    },
    productPrice(item) {
      return item.product_price == null
        ? '价格待定'
        : '¥' + Number(item.product_price).toFixed(2)
    },
    isSelected(item) {
      return this.draftSelected.some(
        (x) => this.productId(x) === this.productId(item)
      )
    },
    openSelector() {
      this.selectorShopId = this.selected[0]?.shop_id || ''
      this.draftSelected = [...this.selected]
      this.selectorTab = 'all'
      this.selectorVisible = true
      this.loadSelector(1)
    },
    toggleProduct(item) {
      if (
        !this.isSelected(item) &&
        this.draftSelected.length &&
        Number(this.draftSelected[0].shop_id) !== Number(item.shop_id)
      )
        return this.$message.warning('只能选择同一家店铺的商品')
      this.draftSelected = this.isSelected(item)
        ? this.draftSelected.filter(
            (x) => this.productId(x) !== this.productId(item)
          )
        : [...this.draftSelected, item]
    },
    togglePage() {
      const all = this.selectorRows.every(this.isSelected)
      this.selectorRows.forEach((x) => {
        if (this.isSelected(x) === all) this.toggleProduct(x)
      })
    },
    changeSelectorTab(tab) {
      this.selectorTab = tab
      this.changeSelectorPage(1)
    },
    changeSelectorPage(page) {
      const p = Math.max(1, Math.min(this.selectorPages, Number(page) || 1))
      if (this.selectorTab === 'all') this.loadSelector(p)
      else {
        this.selectorPage = p
        this.selectorJump = p
      }
    },
    changeSelectorShop(id) {
      this.selectorShopId = id
      this.loadSelector(1)
    },
    async confirmSelected() {
      if (
        this.draftSelected.length &&
        this.draftSelected.some(
          (x) => Number(x.shop_id) !== Number(this.draftSelected[0].shop_id)
        )
      )
        return this.$message.warning('只能选择同一家店铺的商品')
      this.shops = this.draftSelected.length
        ? [Number(this.draftSelected[0].shop_id)]
        : []
      this.selected = [...this.draftSelected]
      this.selectorVisible = false
      this.invalidate()
    },
    async loadSelector(page) {
      const req = ++this.selectorRequest
      this.selectorLoading = true
      const { created_at, ...filters } = this.selectorFilters
      try {
        const data = this.dataOf(
          await getProductSelectorProducts({
            page,
            page_size: this.selectorPageSize,
            ...filters,
            ...(created_at?.length === 2 ? { created_at } : {}),
            ...(this.selectorShopId ? { shop_ids: [this.selectorShopId] } : {}),
          })
        )
        if (req !== this.selectorRequest) return
        this.selectorRows = data.list || []
        this.selectorPage = page
        this.selectorJump = page
        this.selectorTotal = Number(data.pagination?.total || data.total || 0)
      } catch (e) {
        this.$message.error(this.message(e))
      } finally {
        if (req === this.selectorRequest) this.selectorLoading = false
      }
    },
  },
}
</script>

<style scoped src="./batch-modify.css"></style>
<style scoped>
.code-scope-body {
  padding: 14px 16px;
  color: #606266;
  font-size: 12px;
}
.code-scope-panel ::v-deep .el-radio {
  margin: 0;
  font-family: inherit;
  line-height: 28px;
}
.code-scope-panel ::v-deep .el-radio__label,
.code-scope-panel ::v-deep .el-input__inner {
  font-family: inherit;
  font-size: 12px;
}
.code-scope-panel ::v-deep .el-radio__label {
  padding-left: 7px;
}
.code-scope-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
  min-height: 34px;
}
.code-scope-label {
  flex: 0 0 112px;
  color: #303133;
}
.code-scope-row .el-radio-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 16px;
}
.spec-name-scope > .el-select {
  width: 160px;
}
.spec-name-scope > .el-input {
  max-width: 350px;
}
.spec-name-scope {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid #edf0f4;
}
.code-method-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 14px 16px;
  border-top: 1px solid #edf0f4;
}
.code-method-row > .el-radio {
  flex: 0 0 220px;
  margin-top: 6px;
}
.code-methods {
  color: #606266;
  font-family: inherit;
  font-size: 12px;
}
.code-capability-hint {
  margin: 8px 16px 8px 252px;
}
.code-methods ::v-deep .el-radio {
  margin: 0;
  font-family: inherit;
  line-height: 28px;
}
.code-methods ::v-deep .el-radio__label,
.code-methods ::v-deep .el-input__inner,
.code-methods ::v-deep .el-textarea__inner {
  font-family: inherit;
  font-size: 12px;
}
.code-methods button {
  font-family: inherit;
  font-size: 12px;
}
.code-multi-options {
  flex: 1;
  min-width: 0;
}
.code-multi-option {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #edf0f4;
}
.code-multi-option:last-of-type {
  border-bottom: 0;
}
.code-multi-option > .el-checkbox {
  flex: 0 0 180px;
  margin-top: 4px;
}
.code-multi-option > .code-rule-fields {
  flex: 1;
  min-width: 0;
}
.code-multi-option.is-disabled > .code-rule-fields {
  opacity: 0.55;
  pointer-events: none;
}
.sku-table td {
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}
@media (max-width: 700px) {
  .code-capability-hint {
    margin-left: 16px;
  }
  .code-scope-label {
    flex-basis: 100%;
  }
  .spec-name-scope > .el-input {
    width: 100%;
    max-width: none;
  }
  .code-method-row {
    flex-direction: column;
  }
  .code-method-row > .el-radio {
    flex: auto;
    white-space: normal;
  }
  .code-multi-option {
    flex-wrap: wrap;
  }
  .code-multi-option > .el-checkbox {
    flex-basis: 100%;
  }
  .code-multi-options {
    width: 100%;
  }
}
</style>

<style scoped>
.price-spec-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin: 12px 0;
}
.preview .price-preview-table {
  min-width: 1000px;
  table-layout: fixed;
}
.price-preview-table > thead > tr > th:first-child {
  width: 24%;
}
.price-preview-table > thead > tr > th:nth-child(2) {
  width: 52%;
}
.price-preview-table > thead > tr > th:nth-child(3) {
  width: 16%;
}
.price-preview-table > thead > tr > th:last-child {
  width: 8%;
}
.price-preview-table > tbody > tr > td:nth-child(2),
.price-preview-table > thead > tr > th:nth-child(2),
.sku-table td,
.sku-table th {
  text-align: center;
}
.preview .sku-table {
  min-width: 0;
  width: 100%;
  table-layout: fixed;
  background: #fff;
}
.sku-table th,
.sku-table td {
  width: auto;
  padding: 7px 10px;
  overflow-wrap: anywhere;
  text-align: center;
  font-size: 12px;
}
.sku-table th:first-child,
.sku-table th:last-child {
  width: auto;
}
.sku-table .sku-matched {
  background: #f0f9eb;
}
.sku-table .sku-unmatched {
  background: #f5f5f5;
  color: #909399;
}
.sku-table .sku-unknown {
  background: #fdf6ec;
  color: #b88230;
}
.sku-table .sku-matched:hover {
  background: #e1f3d8;
}
.sku-table .sku-unmatched:hover {
  background: #ebebeb;
}
.sku-table .sku-unknown:hover {
  background: #faecd8;
}
.sku-detail-content {
  margin-top: 8px;
  overflow: auto;
  max-height: 500px;
}
.sku-detail-content > p {
  margin: 0;
  color: #909399;
}
.price-sku-list summary {
  color: #1677ff;
  cursor: pointer;
  outline-offset: 2px;
}
.price-sku-list summary:hover {
  text-decoration: underline;
}
.sku-error {
  color: #f56c6c;
}
@media (max-width: 520px) {
  .actions {
    flex-wrap: wrap;
  }
  main {
    padding-bottom: 100px;
  }
  .code-method-row > .el-radio {
    max-width: 100%;
  }
}
</style>
